const SESSION_TYPE_LABEL: Record<string, string> = {
  direct: "1:1 채팅",
  group: "그룹 채팅",
};

/** `session.session_type` as the screens say it. An unknown value is shown as is. */
export function sessionTypeLabel(value: string) {
  return SESSION_TYPE_LABEL[value] ?? value;
}
